module.exports = __webpack_public_path__ + "img/extract_success@2x.c8d51618.png";